import { Injectable } from "@angular/core";
import { Headers, Http, RequestOptions, Response } from "@angular/http";

import { User } from "../_models/index";
import { Globals } from "../../globals"

@Injectable()
export class UserService {
    private token: string;

    constructor(private http: Http, private _global: Globals) {
        let dataToken: any = JSON.parse(localStorage.getItem('currentUser'));
        if (dataToken != null) {
            this.token = 'Bearer ' + dataToken.access_token;
        }
    }

    verify() {
        return this.http.get('/api/verify', this.jwt()).map((response: Response) => response.json());
    }

    getCaptcha() {
        const httpOptions = {
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        };
        return this.http.post(this._global.HOST + '/obtenerCaptcha', {}, httpOptions).map((response: Response) => response.json());
    }

    verifyCaptcha(captcha, key) {
        const httpOptions = {
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        };
        return this.http.post(this._global.HOST + '/check_captcha', {
            'captcha': captcha,
            'key': key
        }, httpOptions).map((response: Response) => response.json());
    }

    forgotPassword(email: string) {
        const httpOptions = {
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        };
        return this.http.post(this._global.HOST + '/recuperarPassword', { email }, httpOptions).map((response: Response) => response.json());
    }

    getAll() {
        return this.http.get('/api/users', this.jwt()).map((response: Response) => response.json());
    }

    getById(id: number) {
        return this.http.get('/api/users/' + id, this.jwt()).map((response: Response) => response.json());
    }

    create(user: User) {
        const httpOptions = {
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        };
        return this.http.post(this._global.HOST + '/RegistrarUsuario', user, httpOptions).map((response: Response) => response.json());
    }

    update(user: User) {
        const httpOptions = {
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        };
        return this.http.post(this._global.HOST + '/ModificarUsuario', user, httpOptions).map((response: Response) => response.json());
    }

    delete(id: number) {
        return this.http.delete('/api/users/' + id, this.jwt()).map((response: Response) => response.json());
    }

    // private helper methods

    private jwt() {
        // create authorization header with jwt token
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.token) {
            let headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
            return new RequestOptions({ headers: headers });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/_services/user.service.ts